/* eslint-disable react/no-unescaped-entities */
import { RightOutlined } from '@ant-design/icons';
import { styleVariables } from '@lib/common';
import { Col, Row } from 'antd';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledStep1WrapperRow = styled(Row).withConfig({
  displayName: "guideline-matching-questioncomponent__StyledStep1WrapperRow",
  componentId: "sc-ng66ev-0"
})(["position:relative;margin-bottom:24px;"]);
var StyledTextRow = styled(Row).withConfig({
  displayName: "guideline-matching-questioncomponent__StyledTextRow",
  componentId: "sc-ng66ev-1"
})(["margin:24px 0;"]);
var StyledImageCol = styled(Col).withConfig({
  displayName: "guideline-matching-questioncomponent__StyledImageCol",
  componentId: "sc-ng66ev-2"
})(["span{width:100% !important;}"]);
var LineWrapperStyle = css(["position:absolute;"]);
var StyledLineWithArrow = styled.div.withConfig({
  displayName: "guideline-matching-questioncomponent__StyledLineWithArrow",
  componentId: "sc-ng66ev-3"
})(["position:relative;width:420px;border-bottom:1px solid ", ";.anticon{position:absolute;right:-4px;top:-7px;}"], styleVariables.colors.gold2);
var StyledLine1 = styled.div.withConfig({
  displayName: "guideline-matching-questioncomponent__StyledLine1",
  componentId: "sc-ng66ev-4"
})(["", " top:40px;left:104px;p{position:absolute;right:-97px;top:-12px;}"], LineWrapperStyle);
var StyledLine2 = styled.div.withConfig({
  displayName: "guideline-matching-questioncomponent__StyledLine2",
  componentId: "sc-ng66ev-5"
})(["", " top:99px;left:117px;p{position:absolute;right:-134px;top:-12px;}"], LineWrapperStyle);
var StyledLine3 = styled.div.withConfig({
  displayName: "guideline-matching-questioncomponent__StyledLine3",
  componentId: "sc-ng66ev-6"
})(["", " bottom:85px;left:163px;p{position:absolute;right:-245px;top:-12px;}"], LineWrapperStyle);
var StyledTitle = styled.p.withConfig({
  displayName: "guideline-matching-questioncomponent__StyledTitle",
  componentId: "sc-ng66ev-7"
})(["font-weight:bold;"]);
var StyledRightOutlined = styled(RightOutlined).withConfig({
  displayName: "guideline-matching-questioncomponent__StyledRightOutlined",
  componentId: "sc-ng66ev-8"
})(["color:", ";"], styleVariables.colors.gold2);
export var GuidelineMatchingQuestion = function GuidelineMatchingQuestion(_ref) {
  var step1Image = _ref.step1Image,
      step2Image1 = _ref.step2Image1,
      step2Image2 = _ref.step2Image2,
      step2Image3 = _ref.step2Image3,
      circleRedImage1 = _ref.circleRedImage1,
      circleRedImage2 = _ref.circleRedImage2,
      circleRedImage3 = _ref.circleRedImage3;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledTitle, {
      children: "B\u01B0\u1EDBc 1: Ch\u1ECDn \"N\u1ED1i k\u1EBFt qu\u1EA3\""
    }), /*#__PURE__*/_jsx("p", {
      children: "Gi\xE1o vi\xEAn b\u1EAFt \u0111\u1EA7u b\u1EB1ng vi\u1EC7c ch\u1ECDn t\xF9y ch\u1ECDn \"N\u1ED1i k\u1EBFt qu\u1EA3\" trong ph\u1EA7n t\u1EA1o c\xE2u h\u1ECFi. T\xF9y ch\u1ECDn n\xE0y s\u1EBD hi\u1EC3n th\u1ECB m\u1ED9t khung so\u1EA1n th\u1EA3o \u0111\u1EB7c bi\u1EC7t \u0111\u1EC3 t\u1EA1o lo\u1EA1i c\xE2u h\u1ECFi n\xE0y."
    }), /*#__PURE__*/_jsxs(StyledStep1WrapperRow, {
      children: [/*#__PURE__*/_jsx(StyledImageCol, {
        span: 12,
        children: step1Image
      }), /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledLine1, {
          children: /*#__PURE__*/_jsxs(StyledLineWithArrow, {
            children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(StyledRightOutlined, {}), /*#__PURE__*/_jsx("p", {
              children: "Khung c\xE2u h\u1ECFi "
            })]
          })
        }), /*#__PURE__*/_jsx(StyledLine2, {
          children: /*#__PURE__*/_jsxs(StyledLineWithArrow, {
            children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(StyledRightOutlined, {}), /*#__PURE__*/_jsx("p", {
              children: "Khung t\u1EA1o l\u1EF1a ch\u1ECDn "
            })]
          })
        }), /*#__PURE__*/_jsx(StyledLine3, {
          children: /*#__PURE__*/_jsxs(StyledLineWithArrow, {
            children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(StyledRightOutlined, {}), /*#__PURE__*/_jsx("p", {
              children: "Khung c\xE2u h\u1ECFi v\xE0 l\u1EF1a ch\u1ECDn t\u01B0\u01A1ng \u1EE9ng"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(StyledTitle, {
      children: "B\u01B0\u1EDBc 2: \u0110i\u1EC1n th\xF4ng tin v\xE0o c\xE1c khung:"
    }), /*#__PURE__*/_jsxs(StyledTextRow, {
      children: [/*#__PURE__*/_jsx(StyledImageCol, {
        span: 1,
        children: circleRedImage1
      }), /*#__PURE__*/_jsx(StyledImageCol, {
        span: 10,
        children: step2Image1
      }), /*#__PURE__*/_jsxs(Col, {
        span: 12,
        offset: 1,
        children: [/*#__PURE__*/_jsx(StyledTitle, {
          children: "Khung c\xE2u h\u1ECFi"
        }), /*#__PURE__*/_jsx("p", {
          children: "T\u1EA1i \u0111\xE2y, gi\xE1o vi\xEAn s\u1EBD nh\u1EADp ch\xEDnh x\xE1c c\xE2u h\u1ECFi c\u1EA7n \u0111\u1EB7t ra cho h\u1ECDc sinh. V\xED d\u1EE5: \"N\u1ED1i c\xE1c th\xE0nh ph\u1ED1 v\u1EDBi qu\u1ED1c gia t\u01B0\u01A1ng \u1EE9ng.\""
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledTextRow, {
      children: [/*#__PURE__*/_jsx(StyledImageCol, {
        span: 1,
        children: circleRedImage2
      }), /*#__PURE__*/_jsx(StyledImageCol, {
        span: 10,
        children: step2Image2
      }), /*#__PURE__*/_jsxs(Col, {
        span: 12,
        offset: 1,
        children: [/*#__PURE__*/_jsx(StyledTitle, {
          children: "Khung t\u1EA1o l\u1EF1a ch\u1ECDn "
        }), /*#__PURE__*/_jsx("p", {
          children: "\u1EDE khung n\xE0y, gi\xE1o vi\xEAn s\u1EBD li\u1EC7t k\xEA t\u1EA5t c\u1EA3 c\xE1c l\u1EF1a ch\u1ECDn (k\u1EBFt qu\u1EA3) c\xF3 th\u1EC3. M\u1ED7i l\u1EF1a ch\u1ECDn s\u1EBD \u0111\u01B0\u1EE3c nh\u1EADp v\xE0o m\u1ED9t d\xF2ng ri\xEAng bi\u1EC7t. V\xED d\u1EE5:"
        }), /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsx("li", {
            children: "H\xE0 N\u1ED9i"
          }), /*#__PURE__*/_jsx("li", {
            children: "Tokyo"
          }), /*#__PURE__*/_jsx("li", {
            children: "Paris"
          }), /*#__PURE__*/_jsx("li", {
            children: "London"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledTextRow, {
      children: [/*#__PURE__*/_jsx(StyledImageCol, {
        span: 1,
        children: circleRedImage3
      }), /*#__PURE__*/_jsx(StyledImageCol, {
        span: 10,
        children: step2Image3
      }), /*#__PURE__*/_jsxs(Col, {
        span: 12,
        offset: 1,
        children: [/*#__PURE__*/_jsx(StyledTitle, {
          children: "Khung c\xE2u h\u1ECFi v\xE0 l\u1EF1a ch\u1ECDn t\u01B0\u01A1ng \u1EE9ng"
        }), /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsx("li", {
            children: "\u0110\xE2y l\xE0 n\u01A1i gi\xE1o vi\xEAn s\u1EBD t\u1EA1o c\xE1c c\u1EB7p c\xE2u h\u1ECFi v\xE0 l\u1EF1a ch\u1ECDn \u0111\xFAng."
          }), /*#__PURE__*/_jsx("li", {
            children: "\u0110i\u1EC1n c\xE2u h\u1ECFi: Nh\u1EADp c\xE2u h\u1ECFi v\xE0o \xF4 \u0111\u1EA7u ti\xEAn c\u1EE7a m\u1ED7i c\u1EB7p."
          }), /*#__PURE__*/_jsx("li", {
            children: "Ch\u1ECDn \u0111\xE1p \xE1n: T\u1EEB danh s\xE1ch c\xE1c l\u1EF1a ch\u1ECDn \u0111\xE3 t\u1EA1o \u1EDF b\u01B0\u1EDBc 2, gi\xE1o vi\xEAn s\u1EBD ch\u1ECDn v\xE0 k\xE9o \u0111\xE1p \xE1n \u0111\xFAng v\xE0o \xF4 th\u1EE9 hai c\u1EE7a c\u1EB7p \u0111\xF3."
          }), /*#__PURE__*/_jsx("ul", {
            children: "V\xED d\u1EE5:"
          }), /*#__PURE__*/_jsx("li", {
            children: "Th\u1EE7 \u0111\xF4 c\u1EE7a Vi\u1EC7t Nam l\xE0: H\xE0 N\u1ED9i"
          }), /*#__PURE__*/_jsx("li", {
            children: "Th\u1EE7 \u0111\xF4 c\u1EE7a Nh\u1EADt B\u1EA3n l\xE0: Tokyo"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(StyledTitle, {
      children: "T\u1ED5ng k\u1EBFt:"
    }), /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx("p", {
        children: "\u0110\u1EC3 t\u1EA1o m\u1ED9t c\xE2u h\u1ECFi n\u1ED1i k\u1EBFt qu\u1EA3, gi\xE1o vi\xEAn c\u1EA7n th\u1EF1c hi\u1EC7n c\xE1c b\u01B0\u1EDBc sau:"
      }), /*#__PURE__*/_jsxs("ol", {
        children: [/*#__PURE__*/_jsx("li", {
          children: "Ch\u1ECDn lo\u1EA1i c\xE2u h\u1ECFi \"N\u1ED1i k\u1EBFt qu\u1EA3\"."
        }), /*#__PURE__*/_jsx("li", {
          children: "Vi\u1EBFt c\xE2u h\u1ECFi ch\xEDnh."
        }), /*#__PURE__*/_jsx("li", {
          children: "Li\u1EC7t k\xEA t\u1EA5t c\u1EA3 c\xE1c l\u1EF1a ch\u1ECDn c\xF3 th\u1EC3."
        }), /*#__PURE__*/_jsx("li", {
          children: "T\u1EA1o c\xE1c c\u1EB7p c\xE2u h\u1ECFi - \u0111\xE1p \xE1n \u0111\xFAng."
        })]
      }), /*#__PURE__*/_jsx("p", {
        children: "L\u01B0u \xFD: "
      }), /*#__PURE__*/_jsxs("ul", {
        children: [/*#__PURE__*/_jsx("li", {
          children: " S\u1ED1 l\u01B0\u1EE3ng c\xE2u h\u1ECFi v\xE0 l\u1EF1a ch\u1ECDn c\xF3 th\u1EC3 thay \u0111\u1ED5i t\xF9y theo y\xEAu c\u1EA7u c\u1EE7a gi\xE1o vi\xEAn."
        }), /*#__PURE__*/_jsx("li", {
          children: "\u0110\u1EC3 t\u1EA1o c\xE2u h\u1ECFi h\u1EA5p d\u1EABn h\u01A1n, gi\xE1o vi\xEAn c\xF3 th\u1EC3 s\u1EED d\u1EE5ng h\xECnh \u1EA3nh ho\u1EB7c c\xE1c y\u1EBFu t\u1ED1 \u0111a ph\u01B0\u01A1ng ti\u1EC7n kh\xE1c."
        })]
      }), "V\u1EDBi h\u01B0\u1EDBng d\u1EABn n\xE0y, hy v\u1ECDng gi\xE1o vi\xEAn s\u1EBD d\u1EC5 d\xE0ng t\u1EA1o ra c\xE1c c\xE2u h\u1ECFi n\u1ED1i k\u1EBFt qu\u1EA3 hi\u1EC7u qu\u1EA3 v\xE0 sinh \u0111\u1ED9ng cho b\xE0i gi\u1EA3ng c\u1EE7a m\xECnh."]
    })]
  });
};